import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('board')
import Utils from "@/helpers/utils.js";

export default {
  namespaced: true,
  state: {
    notices: [],
    boards: {
      list: [],
      totalPage: 0
    },
  },
  mutations: {
    setBoard: (state, data) => {
      let temp = _.map(data.data, (v) => { 
        v['expand'] = false //내용 확장 플래그
        v['images'] = [] // 이미지 배열
        v['files'] = []  // 파일 배열
        v['images'] = _.concat([v['img_url1'], v['img_url2'], v['img_url3']].filter(v => !_.isNil(v) && !_.isEmpty(v)))
        v['files'] = _.concat([v['file1'], v['file2'], v['file3']].filter(v => !_.isNil(v) && !_.isEmpty(v)))

        //링크 추출 및 HTML 변환
        let text = v['content']
        let url = Utils.stringToLink(text)
        if(_.size(url) > 0) {
            for(var i = 0; i < url.length; i++) {
                text = text.replace(url[i], `<a href="${url[i]}" target="_blank">${url[i]}</a>`)
            }
        }
        v['content'] = text.replace(/(?:\r\n|\r|\n)/g, '<BR/>')
        return v
      })

      //상단고정
      let filtered = _.filter(temp, {'top_fix': true})
      _.forEach(_.reverse(filtered), (v) => {
        let index = _.findIndex(temp, {'id': v.id})
        temp.splice(index, 1)
        temp.unshift(v)
      })
      state.boards.list = temp
      state.boards.totalPage = data.totalCount
    },
    setNotice: (state, data) => {
      state.notices = data.data
    },
  },
  actions: {
    getBoards: async ({commit}, payload ) => {
      try {
        const response = await api.get(`board`, { params: payload })
        // console.log("boards :", response.data)
        commit('setBoard', response.data)
        commit('setNotice', response.data)
      } catch (e) {
        console.error('[axios] getBoards :', e.message)
      }
    },
    searchKeyword: async ({commit}, keyword) => {
      try {
        const response = await api.get(`board/search/?keyword=${keyword}`)
        // console.log("boards :", response.data)
        commit('setBoard', response.data)
      } catch (e) {
        console.error('[axios] searchKeyword :', e.message)
      }
    },
    getTopfix: async ({commit}) => {
      try {
        const response = await api.get(`board/list/topfix`)
        // console.log("boards :", response.data)
        commit('setNotice', response.data)
      } catch (e) {
        console.error('[axios] getTopfix :', e.message)
      }
    },
  }
}